import React, { useState } from "react";
import SlotList from "./components/SlotList";
import "./App.css";
import "./index.css";

const App = () => {
  // TEMP test variant to check hours
  const debugVariantId = "54598688801113";
  fetch(
    `https://servicify-appointments.herokuapp.com/api/products/15414942925145/events?variantId=${debugVariantId}`
  ).then((r) => r.json());
  // .then((data) => console.log(data.employees[0].regularHours));

  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  // const [date, setDate] = useState("2025-06-19");

  const restBayProductId = "15414943285593";
  const sandyBayProductId = "15414942925145";
  const restBayPeak = {
    productId: restBayProductId,
    eventId: 89426,
    employeeId: 75984,
    variantId: "54598689456473",
  };
  const restBayOffPeak = {
    productId: restBayProductId,
    eventId: 89372,
    employeeId: 76032,
    variantId: "54598689489241",
  };
  const restBayPrivate = {
    productId: "15414943351129",
    eventId: 89426,
    employeeId: 75984,
    variantId: "54598689554777",
  };
  const sandyBayPeak = {
    productId: sandyBayProductId,
    eventId: 89377,
    employeeId: 49078,
    variantId: "54598688801113", //Think this is peak variant
  };
  const sandyBayOffPeak = {
    productId: sandyBayProductId,
    eventId: 89369,
    employeeId: 76033,
    variantId: "54598688833881",
  };
  const sandyBayPrivate = {
    productId: "15414942990681",
    eventId: 89370,
    employeeId: 49078,
    variantId: "54598688932185",
  };

  // Helper to get display date string
  const getDisplayDate = (dateStr) => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const inputDate = new Date(dateStr);

    // Remove time for comparison
    const isSameDay = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(inputDate, today)) return "Today";
    if (isSameDay(inputDate, tomorrow)) return "Tomorrow";

    return inputDate.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
      // year omitted
    });
  };

  return (
    <div className="app">
      <img
        className="logo"
        src="img/sauna-checker-logo.png"
        alt="Sauna Checker Logo"
      />
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        className="date-picker"
      />
      <p>
        <strong className="date">{getDisplayDate(date)}</strong>
      </p>
      <div className="date-navigation">
        <button
          onClick={() =>
            setDate(
              new Date(new Date(date).setDate(new Date(date).getDate() - 1))
                .toISOString()
                .slice(0, 10)
            )
          }
        >
          Previous day
        </button>
        <button
          onClick={() =>
            setDate(
              new Date(new Date(date).setDate(new Date(date).getDate() + 1))
                .toISOString()
                .slice(0, 10)
            )
          }
        >
          Next day
        </button>
      </div>
      <div className="slotlist">
        <SlotList
          date={date}
          locationName="Sandy bay"
          productId={sandyBayProductId}
          peak={sandyBayPeak}
          offpeak={sandyBayOffPeak}
          privateBook={sandyBayPrivate}
          maxCapacity={10}
          stationKey="sandyBay"
        />
        <SlotList
          date={date}
          locationName="Rest bay"
          productId={restBayProductId}
          peak={restBayPeak}
          offpeak={restBayOffPeak}
          privateBook={restBayPrivate}
          maxCapacity={10}
          stationKey="restBay"
        />
      </div>
    </div>
  );
};

export default App;
